import { render } from "./HomeSlider.vue?vue&type=template&id=908495bc"
import script from "./HomeSlider.vue?vue&type=script&lang=js"
export * from "./HomeSlider.vue?vue&type=script&lang=js"

import "./HomeSlider.vue?vue&type=style&index=0&id=908495bc&lang=css"
script.render = render

export default script